import { array, concat } from '@ember/helper';
import includes from '@nullvoxpopuli/ember-composable-helpers/helpers/includes';
import classNames from 'volta/helpers/class-names';

import type { TOC } from '@ember/component/template-only';

interface BvHrSignature {
  Args: {
    size?: 'full' | 'half' | 'quarter';
  };
  Element: HTMLElement;
}

const BvHrComponent: TOC<BvHrSignature> = <template>
  <hr
    class={{classNames
      'bv-hr'
      (if (includes @size (array 'full' 'half' 'quarter')) (concat 'bv-hr--' @size))
    }}
    ...attributes
  />
</template>;

export default BvHrComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvHr: typeof BvHrComponent;
    'bv-hr': typeof BvHrComponent;
  }
}
